// extracted by mini-css-extract-plugin
export default {"header":"HeaderInfo_header__RPum5","iconButton":"HeaderInfo_iconButton__FYg4D","title":"HeaderInfo_title__TUOod"};